module.exports = __webpack_public_path__ + "img/客服.e137c792.png";